// extracted by mini-css-extract-plugin
module.exports = {"root":"ScrollToTop_root__ZQHlu","scroll-to-top-wrap":"ScrollToTop_scroll-to-top-wrap__xRpTx"};